<div class="emc-ts-container">
    <h2>{{title | translate}}</h2>
    <div class="emc-ts-body">
      <div *ngIf="selectedMainTab == 'Assets' && substationTemplate != null" class="collapsable-card">
            <div class="collapsable-card-header">
                <p class="title">Advanced Map</p>
                <button class="collapse-button" (click)="toggleAdvancedMapDropdown()">
                    <img [class.rotated]="isAdvanceMapOpen" height="24" width="24" src="../../../../../assets/icons/arrow-down-small.svg" />
                </button>
            </div>
            <div *ngIf="isAdvanceMapOpen" class="collapsable-card-content" [appSlideToggle]="isAdvanceMapOpen ? 'open' : 'closed'" [isNormal]="true">
                <div class="recall">
                  <header>
                      <p>{{ 'Image' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('Image', purposeEnum.AdvancedMapImage)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.AdvancedMapImage).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.AdvancedMapImage)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.AdvancedMapImage).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
                <div class="recall">
                  <header>
                      <p>{{ 'Additional Fields' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('Additional Details', purposeEnum.AdvancedMapAdditionalFields)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.AdvancedMapAdditionalFields).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.AdvancedMapAdditionalFields)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.AdvancedMapAdditionalFields).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="collapsable-card">
            <div class="collapsable-card-header">
                <p class="title">List Page</p>
                <button class="collapse-button" (click)="toggleListPageDropdown()">
                    <img [class.rotated]="isListPageOpen" height="24" width="24" src="../../../../../assets/icons/arrow-down-small.svg" />
                </button>  
            </div>
            <div *ngIf="isListPageOpen" class="collapsable-card-content" [appSlideToggle]="isListPageOpen ? 'open' : 'closed'" [isNormal]="true">
                <div class="recall">
                  <header>
                      <p>{{ 'COMMON.CARDS' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.CARDS', purposeEnum.Card)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Card).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.Card)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Card).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
                <div class="recall">
                  <header>
                      <p>{{ 'COMMON.SEARCH' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.SEARCH', purposeEnum.Search)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Search).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.Search)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Search).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
                <div class="recall">
                  <header>
                      <p>{{ 'COMMON.FILTERS' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.FILTERS', purposeEnum.Filter)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Filter).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.Filter)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Filter).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
                <div class="recall">
                    <header>
                        <p>{{ 'COMMON.DOWNLOAD' | translate }}</p>
                        <div class="download-buttons">
                            <label class="toggle-switch">
                                <input type="checkbox" />
                                <span class="switch-slider"></span>
                            </label>
                            <button>
                                <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.DOWNLOAD', purposeEnum.Download)" />
                            </button>
                            <button>
                                <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                            </button>
                        </div>
                    </header>
                    <div class="body">
                      <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Download).length > 0">
                        <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.Download)" class="card-item selected-card">
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>
                          </svg>
                          <span class="card-label">{{ option.labelName }}</span>
                        </div>
                      </div>
                      <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Download).length === 0">
                          <p>No options selected</p>
                      </div>
                  </div>
                </div>
                <div class="recall">
                  <header>
                      <p>{{ 'COMMON.TABLE' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.TABLE', purposeEnum.ListPage)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.ListPage).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.ListPage)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.ListPage).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div *ngIf="showDetailsPage" class="collapsable-card">
            <div class="collapsable-card-header">
                <p class="title">Details Page</p>
                <button class="collapse-button" (click)="toggleDetailsPageDropdown()">
                    <img [class.rotated]="isDetailsPageOpen" height="24" width="24" src="../../../../../assets/icons/arrow-down-small.svg" />
                </button>  
            </div>
            <div *ngIf="isDetailsPageOpen" class="collapsable-card-content" [appSlideToggle]="isDetailsPageOpen ? 'open' : 'closed'" [isNormal]="true">
                <ng-container *ngIf="selectedMainTab == 'Assets'">
                    <app-emc-retag [entityType]="entityType!" [substationTemplate]="substationTemplate!"></app-emc-retag>
                    <app-emc-recall [entityType]="entityType!" [substationTemplate]="substationTemplate!"></app-emc-recall>
                </ng-container>
                <div class="recall">
                  <header>
                      <p>{{ 'COMMON.EDIT' | translate }}</p>
                      <div class="download-buttons">
                          <label class="toggle-switch">
                              <input type="checkbox" />
                              <span class="switch-slider"></span>
                          </label>
                          <button>
                              <img src="../../../../../assets/icons/pencil.svg" data-bs-toggle="modal" data-bs-target="#editModal" (click)="selectSection('COMMON.EDIT', purposeEnum.Edit)" />
                          </button>
                          <button>
                              <img src="../../../../../assets/icons/delete-trash-can.svg" />               
                          </button>
                      </div>
                  </header>
                  <div class="body">
                    <div class="cards-container" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Edit).length > 0">
                      <div *ngFor="let option of getSelectedOptionsForPurpose(purposeEnum.Edit)" class="card-item selected-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 0.167969C2.77842 0.167969 0.166748 2.77964 0.166748 6.0013C0.166748 9.22296 2.77842 11.8346 6.00008 11.8346C9.22174 11.8346 11.8334 9.22296 11.8334 6.0013C11.8334 2.77964 9.22174 0.167969 6.00008 0.167969ZM8.08869 4.82001C8.24169 4.633 8.21413 4.35737 8.02712 4.20436C7.84012 4.05136 7.56448 4.07892 7.41147 4.26593L5.0926 7.1001L4.26777 6.27528C4.09692 6.10442 3.81991 6.10442 3.64906 6.27528C3.4782 6.44613 3.4782 6.72314 3.64906 6.89399L4.81572 8.06066C4.90312 8.14806 5.02342 8.19442 5.14687 8.18826C5.27033 8.1821 5.38542 8.12401 5.46369 8.02834L8.08869 4.82001Z" fill="white"/>                      
                        </svg>
                        <span class="card-label">{{ option.labelName }}</span>
                      </div>
                    </div>
                    <div class="no-options-message" *ngIf="getSelectedOptionsForPurpose(purposeEnum.Edit).length === 0">
                        <p>No options selected</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content emc-modal-content" (click)="$event.stopPropagation()">
      <div class="emc-modal-header">
        <h5 class="modal-title">
          {{ selectedSection | translate }}
        </h5>
        <div class="header-buttons">
          <button *ngIf="currentPurpose === purposeEnum.AdvancedMapAdditionalFields" class="btn-preview" (click)="openPreview()">Preview</button>
          <svg data-bs-dismiss="modal" class="emc-btn-close" (click)="closeModal()" width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <div class="emc-modal-body">
        <!-- Selected Cards (Top Section) -->
        <div 
            class="cards-container selected-cards-container" 
            *ngIf="tempSelectedOptions.length > 0"
            cdkDropList
            cdkDropListOrientation="mixed"
            [cdkDropListData]="tempSelectedOptions"
            (cdkDropListDropped)="onSelectedCardDrop($event)"
        >
          <div
            *ngFor="let option of tempSelectedOptions"
            class="card-item selected-card" 
            cdkDrag
          >
            <span class="card-label">{{ option.labelName }}</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" cdkDragHandle>
              <path d="M4.375 3.35482C4.375 2.79103 4.83204 2.33398 5.39583 2.33398C5.95962 2.33398 6.41667 2.79103 6.41667 3.35482C6.41667 3.91861 5.95962 4.37565 5.39583 4.37565C4.83204 4.37565 4.375 3.91861 4.375 3.35482Z" fill="white"/>
              <path d="M7.5835 3.35482C7.5835 2.79103 8.04054 2.33398 8.60433 2.33398C9.16812 2.33398 9.62516 2.79103 9.62516 3.35482C9.62516 3.91861 9.16812 4.37565 8.60433 4.37565C8.04054 4.37565 7.5835 3.91861 7.5835 3.35482Z" fill="white"/>
              <path d="M4.375 10.6458C4.375 10.082 4.83204 9.625 5.39583 9.625C5.95962 9.625 6.41667 10.082 6.41667 10.6458C6.41667 11.2096 5.95962 11.6667 5.39583 11.6667C4.83204 11.6667 4.375 11.2096 4.375 10.6458Z" fill="white"/>
              <path d="M7.5835 10.6458C7.5835 10.082 8.04054 9.625 8.60433 9.625C9.16812 9.625 9.62516 10.082 9.62516 10.6458C9.62516 11.2096 9.16812 11.6667 8.60433 11.6667C8.04054 11.6667 7.5835 11.2096 7.5835 10.6458Z" fill="white"/>
              <path d="M4.375 6.94271C4.375 6.37892 4.83204 5.92188 5.39583 5.92188C5.95962 5.92188 6.41667 6.37892 6.41667 6.94271V7.00104C6.41667 7.56483 5.95962 8.02188 5.39583 8.02188C4.83204 8.02188 4.375 7.56483 4.375 7.00104V6.94271Z" fill="white"/>
              <path d="M7.5835 6.94271C7.5835 6.37892 8.04054 5.92188 8.60433 5.92188C9.16812 5.92188 9.62516 6.37892 9.62516 6.94271V7.00104C9.62516 7.56483 9.16812 8.02188 8.60433 8.02188C8.04054 8.02188 7.5835 7.56483 7.5835 7.00104V6.94271Z" fill="white"/>
            </svg>

            <svg (click)="toggleSelection(option); $event.stopPropagation()" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="all-options-container">
          <!-- Search -->
          <div class="search-container">
            <input
              type="text"
              class="form-control search-input"
              placeholder="Search"
              [(ngModel)]="searchTerm"
              (input)="filterOptions()"
            />
          </div>
  
          <!-- All Available Cards -->
          <div class="cards-container">
            <div
              *ngFor="let option of filteredOptions"
              class="card-item"
              [class.selected]="isSelected(option)"
              (click)="toggleSelection(option)"
            >
              <span class="card-label">{{ option.labelName }}</span>
              <i
                class="bi"
                [class.bi-check-circle-fill]="isSelected(option)"
                [class.bi-circle]="!isSelected(option)"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div class="emc-modal-footer">
        <button
          type="button"
          class="btn btn-cancel"
          data-bs-dismiss="modal"
          #closeEmcModal
          (click)="closeModal()"
        >
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-save"
          (click)="saveSelection()"
        >
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-adv-map-preview-modal 
  *ngIf="isPreviewOpen"
  [substationTemplate]="substationTemplate"
  [dynamicOptions]="tempSelectedOptions"
  (close)="closePreview()">
</app-adv-map-preview-modal>